module.exports = __webpack_public_path__ + "img/delete_table.ace7b722.svg";